// 供应商管理
export const SUPPLIERGETPAGE = 'SUPPLIERGETPAGE'
export const UPDATESTATUS = 'UPDATESTATUS'
export const SUPPLIERADD = 'SUPPLIERADD'
export const SUPPLIERUPDATA = 'SUPPLIERUPDATA'
export const SUPPLIERUPDATEPWD = 'SUPPLIERUPDATEPWD'
export const GETSUPPLIERCOST = 'GETSUPPLIERCOST'
export const SUPPLIERADDCOST = 'SUPPLIERADDCOST'
export const GETCOSTBYID = 'GETCOSTBYID'
export const SUPPLIERUPDATECOST = 'SUPPLIERUPDATECOST'
export const SUPPLIERDELETE = 'SUPPLIERDELETE'
// export const SUPPLIERGETSUPPLIER = 'SUPPLIERGETSUPPLIER'
// export const GETCHIDE = 'GETCHIDE'

// ============================商户端=========================
export const GETSUPPLIERLISTMANAGE = 'GETSUPPLIERLISTMANAGE'
export const REMOVESUPPLIER = 'REMOVESUPPLIER'
export const GETSUPPLIERLISTPANEL = 'GETSUPPLIERLISTPANEL'
export const GETSUPPLIER = 'GETSUPPLIER'
export const SAVESUPPLIER = 'SAVESUPPLIER'
export const GETSUPPLIERPRINT = 'GETSUPPLIERPRINT'
export const SAVESUPPLIERPRINT = 'SAVESUPPLIERPRINT'
export const CHECKREMOVESUPPLIER = 'CHECKREMOVESUPPLIER'
// ============================SAAS=========================
export const GETALLSUPPLIERLISTSAAS = 'GETALLSUPPLIERLISTSAAS'
export const GETSUPPLIERWAREHOUSELISTSAAS = 'GETSUPPLIERWAREHOUSELISTSAAS'
export const CHECKDELETESUPPLIERSAAS = 'CHECKDELETESUPPLIERSAAS'
export const DELETESUPPLIERSAAS = 'DELETESUPPLIERSAAS'
export const GETSUPPLIERSAAS = 'GETSUPPLIERSAAS'
export const CHECKDELETESUPPLIERCONTACTPERSONSAAS = 'CHECKDELETESUPPLIERCONTACTPERSONSAAS'
export const GETYCDISPATCHPLATFORMPOINT = 'GETYCDISPATCHPLATFORMPOINT'

export const SAVESUPPLIERSAAS = 'SAVESUPPLIERSAAS'
export const IMPORTSUPPLIER = 'IMPORTSUPPLIER'



// WEBPACK FOOTER //
// ./src/store/supplierManage/types.js